import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Read Our 5-Star Reviews | Ship&Play',
  description:
    'Don’t take our word for it—see what real users have to say about their ' +
    'experience traveling stress-free with Ship&Play.',
  alternates: {
    canonical: 'https://www.shipplay.com/reviews',
  },
}

export default metadata
